import { styled } from '@mui/material';

export const H1 = styled('h1')(({ theme }) => ({
    fontSize: '24px',
    lineHeight: '24px',
    fontWeight: 'bold',
    margin: '0 0 16px 0',
    color: theme.palette.text.primary,
    padding: 0,
    [theme.breakpoints.up('sm')]: {
        fontSize: '44px',
        lineHeight: '56px',
        margin: '0 0 24px 0',
    },
}));
